import {Image} from '@/_application/core/components/ui/image';
import CheckIcon from '@/_application/icons/check-icon';
import {Routes} from '@/config/routes';
import Link from 'next/link';
import {GuestInfo} from './kidsplaza-spring.desktop.guest-info';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import SocialNetwork from '../user-info-card/social-network/social-network';

const bannerDownloadApp = getImageAssetUrl('images/download-app-banner-204x153.png');

export function GuestInfoCard() {
    return (
        <div className={`hidden w-57.5 rounded-xl bg-gradient-blue-white px-3.5 py-2.5 xl:block`}>
            <GuestInfo />

            <div className="mb-3 flex h-18.5 gap-1">
                <div className="flex w-[34%] flex-col items-center justify-center gap-1 rounded-[10px] bg-white pb-1 pt-2 text-center text-primary">
                    <CheckIcon className="mx-auto h-5 w-4.5 text-center" />
                    <span className="text-[10px] leading-3.5">Quản lý đơn hàng</span>
                </div>
                <div className="flex w-[28%] flex-col items-center justify-center gap-1 rounded-[10px] bg-white pb-1 pt-2 text-center text-primary">
                    <CheckIcon className="mx-auto h-5 w-4.5 text-center" />
                    <span className="text-[10px] leading-3.5">Tích điểm Kicoin</span>
                </div>
                <div className="flex w-[38%] flex-col items-center justify-center gap-1 rounded-[10px] bg-white pb-1 pt-2 text-center text-primary">
                    <CheckIcon className="mx-auto h-5 w-4.5 text-center" />
                    <span className="text-[10px] leading-3.5">Quản lý thông tin tài khoản</span>
                </div>
            </div>

            <Link href={`${Routes.appDownload}`} className="mb-2 block  transition-opacity hover:opacity-80">
                <Image
                    src={bannerDownloadApp}
                    alt="Banner"
                    height={148}
                    width={203}
                    priority
                    className="rounded-[10px]"
                />
            </Link>

            <SocialNetwork />
        </div>
    );
}
